import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=5fc10df2&scoped=true&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=5fc10df2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc10df2",
  null
  
)

export default component.exports